"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get DEFAULT_STATUS_FILTER () {
        return DEFAULT_STATUS_FILTER;
    },
    get createStatusFilterSchema () {
        return createStatusFilterSchema;
    }
});
const _zod = require("zod");
const DEFAULT_STATUS_FILTER = "active";
function createStatusFilterSchema(statuses, defaultStatus = DEFAULT_STATUS_FILTER) {
    // A default parameter is type-checked once against the constraint, never per call site, and
    // zod's .default() skips parsing — so a statuses tuple lacking this default would sail through.
    if (defaultStatus !== "any" && !statuses.includes(defaultStatus)) {
        throw new Error(`Status filter default "${defaultStatus}" is not one of: any, ${statuses.join(", ")}`);
    }
    // TS loses tuple literal-ness through the generic spread; cast matches zod's own ToEnum shape.
    const schema = _zod.z.enum([
        "any",
        ...statuses
    ]);
    return schema.default(defaultStatus);
}
